import React, { useState, useEffect } from "react";
import './ScrollUp.css'; // Pastikan untuk membuat file CSS

const ScrollUp = () => {
    // State untuk menyimpan informasi perangkat
    const [deviceType, setDeviceType] = useState("desktop");
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const userAgent = navigator.userAgent.toLowerCase();

        // Deteksi apakah perangkat mobile atau desktop
        if (userAgent.includes("iphone") || userAgent.includes("android")) {
            setDeviceType("mobile");
        } else if (userAgent.includes("ipad") || userAgent.includes("tablet")) {
            setDeviceType("tablet");
        } else {
            setDeviceType("desktop");
        }

        const toggleVisibility = () => {
            if (window.pageYOffset > 300) {
                setIsVisible(true);
            } else {
                setIsVisible(false);
            }
        };

        window.addEventListener('scroll', toggleVisibility);

        return () => {
            window.removeEventListener('scroll', toggleVisibility);
        };
    }, []);

    // Conditional rendering berdasarkan jenis perangkat
    const isMobile = deviceType === "mobile";

    // Fungsi untuk scroll ke atas
    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
    };

    const fillColor = deviceType === "mobile" ? "#ffffff" : "#000000";

    return (
        isVisible && (
            <div
                className={`scroll-up ${isMobile ? 'mobile-scroll-up' : 'desktop-scroll-up'}`}
                onClick={scrollToTop}
                style={{ display: isVisible ? 'flex' : 'none' }}
            >
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    aria-hidden="true"
                    role="img"
                    className="icon t-icon"
                    width="36px"
                    height="36px"
                    viewBox="0 0 24 24"
                >
                    <path
                        fill={fillColor}
                        d="M12.71 12.54a1 1 0 0 0-1.42 0l-3 3A1 1 0 0 0 9.71 17L12 14.66L14.29 17a1 1 0 0 0 1.42 0a1 1 0 0 0 0-1.42Zm-3-1.08L12 9.16l2.29 2.3a1 1 0 0 0 1.42 0a1 1 0 0 0 0-1.42l-3-3a1 1 0 0 0-1.42 0l-3 3a1 1 0 0 0 1.42 1.42"
                    ></path>
                </svg>
            </div>
        )
    );
};

export default ScrollUp;
